import "./DuplicateOrdersNotificationDialog.scss";
import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {Observable} from "rxjs";
import {DuplicateOrderSummaries} from "../../types/DuplicateOrdersVettingResponse";
import {DuplicateOrdersNotificationDialogController} from "./DuplicateOrdersNotificationDialogController";

export class DuplicateOrdersNotificationDialog {

    public static id = "duplicateOrdersNotificationDialog";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {

    }

    public open(duplicates: DuplicateOrderSummaries): Observable<boolean> {
        const settings: IModalSettings = {
            templateUrl: "app/portfolio/templates/ticket/place-order-wizard/dialog/DuplicateOrdersNotificationDialogTemplate.html",
            controller: DuplicateOrdersNotificationDialogController,
            controllerAs: "ctrl",
            resolve: {
                duplicates: () => duplicates
            },
            backdrop: "static",
            windowClass: "duplicate-orders-notification-dialog"
        };
        const instance = this.$uibModal.open(settings);
        return Observable.fromPromise(instance.result)
                         .catch(() => Observable.of(false));
    }
}
